(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const stickyAtc = document.getElementById('sticky-atc');
    const footer = document.getElementById('footer');

    if (!stickyAtc || !footer) return;

    // Function to check if footer is visible
    function handleStickyAtcVisibility() {
      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const stickyAtcHeight = stickyAtc.offsetHeight;

      // Add extra buffer space (20px) to ensure sticky ATC hides before overlapping
      const buffer = 20;

      // If footer is visible in viewport (with buffer for sticky ATC height), hide sticky ATC
      if (footerRect.top < windowHeight - stickyAtcHeight - buffer) {
        stickyAtc.classList.remove('show');
      } else {
        stickyAtc.classList.add('show');
      }
    }

    // Check on scroll with debounce for better performance
    let scrollTimeout;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollTimeout) {
          window.cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = window.requestAnimationFrame(handleStickyAtcVisibility);
      },
      { passive: true }
    );

    // Check on resize
    window.addEventListener('resize', handleStickyAtcVisibility, { passive: true });

    // Initial check
    handleStickyAtcVisibility();

    // Hide sticky ATC when offcanvas menu opens
    const offcanvasMenu = document.getElementById('offcanvas-menu');
    if (offcanvasMenu) {
      offcanvasMenu.addEventListener('show.bs.offcanvas', function () {
        stickyAtc.style.display = 'none';
      });

      offcanvasMenu.addEventListener('hide.bs.offcanvas', function () {
        stickyAtc.style.display = '';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
